import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { Button, DialogContent, DialogContentText, DialogTitle } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import { DialogActionsBar } from "@carrotfertility/carotene-core-x"
import React from "react"
import { useCarrotMatch } from "#/components/carrot-match-fertility-clinic-precision-matching/context/CarrotMatchContext"
import { useHandleDialogClose } from "#/components/carrot-match-fertility-clinic-precision-matching/utils/dialogUtil"

export function CloseWithoutAMatchStep() {
  const { back } = useStateMachine()
  const { resetCarrotMatchInteraction, setIsCarrotMatchDialogOpen, carrotMatchInteraction } = useCarrotMatch()
  const { entryPoint } = carrotMatchInteraction

  const { handleClose } = useHandleDialogClose(resetCarrotMatchInteraction, setIsCarrotMatchDialogOpen, entryPoint)

  return (
    <>
      <DialogTitle id="step-heading">
        <FormattedMessage defaultMessage="Close without a match?" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <FormattedMessage defaultMessage="Your answers won’t be saved." />
        </DialogContentText>
      </DialogContent>
      <DialogActionsBar
        primaryAction={
          <Button onClick={() => back()}>
            <FormattedMessage defaultMessage="Keep matching" />
          </Button>
        }
        secondaryAction={
          <Button variant="outlined" color="secondary" onClick={handleClose}>
            <FormattedMessage defaultMessage="Close" />
          </Button>
        }
      />
    </>
  )
}
